import { Show } from "solid-js";
import { Portal } from "solid-js/web";
import { Dialog } from "@ark-ui/solid";
import { IconButton, TextButton } from "../button/Button";
import { useTranslation } from "../../state/i18n";
import introImage from "../../assets/editor/tour/intro.webp";
import { DECORATIVE_IMAGE_ALT } from "../../constants";

type WelcomeModalProps = {
  open: boolean;
  onDismiss: () => void;
};

export const WelcomeModal = (props: WelcomeModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog.Root
      closeOnInteractOutside={true}
      open={props.open}
      onOpenChange={(e) => {
        if (!e.open) {
          props.onDismiss();
        }
      }}
    >
      <Dialog.Context>
        {(context) => (
          <Show when={context().open}>
            <Portal>
              <Dialog.Backdrop class="fixed inset-0 z-10 size-full bg-overlay-default" />
              <Dialog.Positioner class="fixed inset-0 z-10 flex size-full items-center justify-center rounded-lg shadow-elevation-light-5">
                <Dialog.Content class="relative w-120 rounded-lg bg-surface-default">
                  <div class="p-1">
                    <IconButton
                      icon="x"
                      variant="tertiary"
                      class="ml-auto"
                      aria-label={t(($) => $.CLOSE_BUTTON)}
                      onClick={() => props.onDismiss()}
                    />
                  </div>
                  <img src={introImage} alt={DECORATIVE_IMAGE_ALT} />
                  <div class="p-6">
                    <Dialog.Title class="mb-2 text-header-xl text-primary">
                      {t(($) => $.WELCOME_MODAL_TITLE)}
                    </Dialog.Title>
                    <Dialog.Description class="text-medium-regular text-secondary">
                      {t(($) => $.WELCOME_MODAL_DESCRIPTION)}
                    </Dialog.Description>
                    <div class="mt-6 ml-auto flex gap-2">
                      <TextButton
                        block
                        variant="secondary"
                        text={t(($) => $.WELCOME_MODAL_DOWNLOAD_APP_BUTTON_TITLE)}
                        onClick={() => {
                          props.onDismiss();
                          window.open("https://app.moreapp.com", "_self", "noopener");
                        }}
                      />
                      <TextButton
                        block
                        autofocus
                        variant="primary"
                        text={t(($) => $.WELCOME_MODAL_GET_STARTED_BUTTON_TITLE)}
                        onClick={() => props.onDismiss()}
                      />
                    </div>
                  </div>
                </Dialog.Content>
              </Dialog.Positioner>
            </Portal>
          </Show>
        )}
      </Dialog.Context>
    </Dialog.Root>
  );
};

export default WelcomeModal;
